export default {"src":"/_next/static/media/t-mobile.3fb6af6a.svg","height":110,"width":526};